/** The photo gallery piece, standard look over its behavior half. */
import { PhotoGalleryView } from './PhotoGalleryView';
import { usePhotoGallery, type PhotoGalleryInput } from './usePhotoGallery';

export function PhotoGallery(props: PhotoGalleryInput) {
  return <PhotoGalleryView {...usePhotoGallery(props)} />;
}
